import { menuItem } from "modules/helpers";
import GettingStarted from "./GettingStarted.doc";
import StylingGuide from "./StylingGuide.doc";
import UsingCustomIcons from "./UsingCustomIcons.doc";
import Reference from "./Reference.doc";

export default [
  menuItem("Getting Started", "getting-started", GettingStarted),
  menuItem("Styling Guide", "styling-guide", StylingGuide),
  menuItem("Using Custom Icons", "using-custom-icons", UsingCustomIcons),
  menuItem("Reference", "reference", Reference),
];
